<template>
  <main-template>
    <v-row align="center" class="mb-1">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Gerenciar Faltas Justificadas
        </h1>
      </v-col>
      <v-col cols="auto">
        <v-chip v-if="totalPendentes > 0" color="warning" dark small>
          {{ totalPendentes }} pendente{{ totalPendentes !== 1 ? "s" : "" }}
        </v-chip>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-tabs v-model="aba" background-color="transparent">
        <v-tab>
          Pendentes
          <v-badge
            v-if="totalPendentes > 0"
            :content="totalPendentes"
            color="warning"
            inline
            class="ml-1"
          />
        </v-tab>
        <v-tab>Histórico</v-tab>
      </v-tabs>

      <v-divider />

      <v-tabs-items v-model="aba">
        <v-tab-item>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headersPendentes"
              :items="pendentes"
              :loading="carregando"
              no-data-text="Nenhuma justificativa pendente"
              loading-text="Carregando..."
              class="cursor-pointer"
              @click:row="abrirDetalhe"
            >
              <template #[`item.colaborador`]="{ item }">
                {{ item.colaborador?.name || "—" }}
              </template>
              <template #[`item.data_inicio`]="{ item }">
                {{ formatarData(item.data_inicio) }}
                <span v-if="item.data_fim" class="grey--text">
                  até {{ formatarData(item.data_fim) }}</span
                >
              </template>
              <template #[`item.created_at`]="{ item }">
                {{ formatarDataHora(item.created_at) }}
              </template>
              <template #[`item.documento`]="{ item }">
                <v-icon v-if="item.documento" small color="primary">mdi-paperclip</v-icon>
                <span v-else class="grey--text">—</span>
              </template>
              <template #[`item.acoes`]="{ item }">
                <v-btn
                  icon
                  small
                  color="primary"
                  title="Ver detalhes"
                  @click.stop="abrirDetalhe(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <v-tab-item>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headersHistorico"
              :items="historico"
              :loading="carregando"
              no-data-text="Nenhuma justificativa avaliada"
              loading-text="Carregando..."
              @click:row="abrirDetalhe"
            >
              <template #[`item.colaborador`]="{ item }">
                {{ item.colaborador?.name || "—" }}
              </template>
              <template #[`item.data_inicio`]="{ item }">
                {{ formatarData(item.data_inicio) }}
                <span v-if="item.data_fim" class="grey--text">
                  até {{ formatarData(item.data_fim) }}</span
                >
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip small :color="corStatus(item.status)" dark>{{ item.status }}</v-chip>
              </template>
              <template #[`item.avaliador`]="{ item }">
                {{ item.avaliador?.name || "—" }}
              </template>
              <template #[`item.avaliado_em`]="{ item }">
                {{ formatarData(item.avaliado_em) }}
              </template>
              <template #[`item.documento`]="{ item }">
                <v-icon v-if="item.documento" small color="primary">mdi-paperclip</v-icon>
                <span v-else class="grey--text">—</span>
              </template>
              <template #[`item.acoes`]="{ item }">
                <v-btn
                  icon
                  small
                  color="primary"
                  title="Ver detalhes"
                  @click.stop="abrirDetalhe(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <falta-justificada-detail-dialog
      v-model="dialog"
      :falta="faltaSelecionada"
      @avaliado="carregar"
    />
  </main-template>
</template>

<script>
import FaltaJustificadaDetailDialog from "@/components/Colaboradores/FaltaJustificadaDetailDialog.vue";

export default {
  name: "GerenciarFaltasJustificadasPage",
  components: { FaltaJustificadaDetailDialog },
  data() {
    return {
      aba: 0,
      todas: [],
      carregando: false,
      dialog: false,
      faltaSelecionada: null,
      headersPendentes: [
        { text: "Colaborador", value: "colaborador" },
        { text: "Data da Falta", value: "data_inicio" },
        { text: "Motivo", value: "motivo" },
        { text: "Enviado em", value: "created_at" },
        { text: "Anexo", value: "documento", align: "center", sortable: false },
        { text: "", value: "acoes", sortable: false, align: "center", width: "50" },
      ],
      headersHistorico: [
        { text: "Colaborador", value: "colaborador" },
        { text: "Data da Falta", value: "data_inicio" },
        { text: "Motivo", value: "motivo" },
        { text: "Status", value: "status", align: "center" },
        { text: "Avaliador", value: "avaliador" },
        { text: "Avaliado em", value: "avaliado_em" },
        { text: "Anexo", value: "documento", align: "center", sortable: false },
        { text: "", value: "acoes", sortable: false, align: "center", width: "50" },
      ],
    };
  },
  computed: {
    pendentes() {
      return this.todas.filter((f) => f.status === "pendente");
    },
    historico() {
      return this.todas.filter((f) => f.status !== "pendente");
    },
    totalPendentes() {
      return this.pendentes.length;
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        this.todas = await this.$services.colaboradorPontosService.listarTodasFaltasJustificadas();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    abrirDetalhe(falta) {
      this.faltaSelecionada = falta;
      this.dialog = true;
    },
    corStatus(status) {
      return { pendente: "orange", aprovado: "green", reprovado: "red" }[status] || "grey";
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarDataHora(data) {
      if (!data) return "—";
      return new Date(data).toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
.cursor-pointer >>> tbody tr {
  cursor: pointer;
}
</style>
